import React, { useState } from 'react';
import { Box, Paper, Typography, CircularProgress, Alert, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip } from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSubscriptionHistory } from '../../../redux/actions/billingActions';
import useCallOnce from '../../../hooks/useCallOnce';

function StripeBillingHistory() {
  const dispatch = useDispatch();
  const { subscriptionHistory, historyLoading, historyError } = useSelector((state) => state.billing);

  const fetchHistory = () => {
    dispatch(fetchSubscriptionHistory());
    return undefined;
  };

  useCallOnce('billing/fetchSubscriptionHistory', fetchHistory);

  const fmtDateTime = (iso) => {
    if (!iso) return '-';
    try {
      return new Date(iso).toLocaleString();
    } catch (_) {
      return iso;
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ p: { xs: 2, sm: 3 }, border: '1px solid #e5e7eb', borderRadius: 2, boxShadow: 'none', backgroundColor: '#ffffff' }}>
        {/* <Typography variant="h6" sx={{ fontWeight: 700, color: '#111827', mb: 2 }}>
           Billing History
        </Typography> */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <AccountBalanceIcon sx={{ 
              fontSize: { xs: 20, sm: 24 }, 
              color: '#6b7280', 
              mr: 1.5 
            }} />
            <Typography variant="h6" sx={{ 
              fontWeight: 600,
              color: '#111827',
              fontSize: { xs: '1.1rem', sm: '1.25rem' }
            }}>
              Billing History
            </Typography>
          </Box>

        {historyLoading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress size={40} sx={{ color: '#111827' }} />
          </Box>
        )}

        {historyError && (
          <Alert severity="error" sx={{ mb: 2 }}>{historyError}</Alert>
        )}

        {!historyLoading && !historyError && (
          <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2, maxHeight: 48 * 10 + 56, overflowY: 'auto' }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600 }}>Created</TableCell>
                  
                  <TableCell sx={{ fontWeight: 600 }}>Plan</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Price</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Interval</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Current Period</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Next Billing</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                  {/* <TableCell sx={{ fontWeight: 600 }}>Stripe Sub ID</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {subscriptionHistory.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={8} align="center" sx={{ color: '#6b7280' }}>
                      No history available
                    </TableCell>
                  </TableRow>
                )}
                {subscriptionHistory.map((item) => (
                  <TableRow key={item._id}>
                    <TableCell>{fmtDateTime(item.created)}</TableCell>
                    
                    <TableCell>{item?.plan || '-'}</TableCell>
                    {/* <TableCell>{fmtMoney(item?.price)}</TableCell> */}
                    <TableCell>{item?.price}</TableCell>
                    <TableCell>{item?.interval || '-'}</TableCell>
                    <TableCell>
                      {fmtDateTime(item?.currentPeriod?.start)} - {fmtDateTime(item?.currentPeriod?.end)}
                    </TableCell>
                    <TableCell>{fmtDateTime(item.nextBilling)}</TableCell>
                    <TableCell>
                      <Chip
                        label={item.status || '-'}
                        size="small"
                        sx={{
                          backgroundColor: item.status === 'active' ? '#10b981' : item.status === 'canceled' ? '#ef4444' : '#6b7280',
                          color: '#ffffff',
                          fontWeight: 600
                        }}
                      />
                    </TableCell>
                    {/* <TableCell>{item.stripeSubscriptionId || '-'}</TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>
    </Box>
  );
}

export default StripeBillingHistory;


